import React from "react";
import { useLocation } from "react-router-dom";
import MPMCModuleSubtopic from "../MPMCModuleSubtopic";

const MPMC_MachineCycle = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <MPMCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Machine Cycle"
      videos={[
        "https://www.youtube.com/embed/cwqFzGT1FVk", // Machine cycle and time delay calculations in 8051
      ]}
      takeaways={[
        { text: "Cover all topics explained in the video." },
        { text: "Be prepared for questions on loop execution counts and time delay calculations." },
        { text: "Nested loops (usually three levels) are often used in time delay calculations." },
        { text: "Understand how to write code to generate a given time delay." },
        { text: "Differentiate between single-loop and nested-loop implementations for delays ≤255 and >255." },
      ]}
      questions={[]} // No specific previous questions provided
      exampleVideos={[]} // No example question videos provided
    />
  );
}

export default MPMC_MachineCycle;
